import { Dialog, DialogTitle, Grid } from "@mui/material"
import DialogButton from "./Components/DialogButton"
import DialogGridButton from "./Components/DialogGridButton"
import DialogGridText from "./Components/DialogGridText"
import DialogTypographyText from "./Components/DialogTypographyText"
import React from "react"

interface IIformationDialogProps {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    title: string,
    text: React.ReactNode,
    confirmText: string,
    confirm: () => void,
}

const InformationDialog: React.FC<IIformationDialogProps> = (props) => {

    const handleClose = () => {
        props.setOpen(false)
    }

    const handleConfirm = () => {
        props.confirm()
        props.setOpen(false)
    }

    return (
        <Dialog onClose={handleClose} open={props.open} maxWidth="sm">
            <DialogTitle>{props.title}</DialogTitle>
            <Grid container>
                <Grid container>
                    <DialogGridText item xs={12} style={{paddingLeft: "1rem", paddingRight: "1rem"}}>
                        <DialogTypographyText style={{ textAlign: "justify" }}>
                            {props.text}
                        </DialogTypographyText>
                    </DialogGridText>
                </Grid>
                <DialogGridButton container>
                    <Grid item xs={12} >
                        <DialogButton color={"primary"} variant="contained" onClick={handleConfirm}>
                            {props.confirmText}
                        </DialogButton>
                    </Grid>
                </DialogGridButton>
            </Grid>
        </Dialog>
    )
}

export default InformationDialog